<template>
  <div class="details-content__dashboard content-dashboard">
    <div class="content-dashboard__infos dashboard-infos">
      <address-details-dashboard-location :address="address" />
      <address-details-dashboard-offers :address="address" />
      <address-details-dashboard-contacts :address="address" />
    </div>
    <template v-if="isImpersonated">
      <button
        v-if="!deleting"
        class="content-dashboard__delete btn btn--secondary btn--with-icon"
        :class="{ disabled: !deletable, tooltip: !deletable }"
        @click="deleting = deletable"
      >
        {{ trans('addresses.details.dashboard.delete') }}
        <!-- eslint-disable vue/no-v-html -->
        <span v-if="!deletable" class="tooltiptext" v-html="trans('addresses.body.table.delete.tooltip')" />
        <!-- eslint-enable vue/no-v-html -->
      </button>
      <div v-else class="content-dashboard__deleting dashboard-deleting">
        <button
          class="dashboard-deleting__confirm btn btn--secondary red btn--with-icon"
          :class="{ 'loading-btn': deletingConfirmed }"
          @click="deleteAddress"
        >
          <span>{{ trans('addresses.details.dashboard.delete.confirm') }}</span>
        </button>
        <button
          class="dashboard-deleting__cancel btn btn--secondary"
          :class="{ disabled: deletingConfirmed }"
          @click="deleting = false"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import { flashBagError } from '@tools/flashbag';
import { requestsMixin } from '@tools/requests-mixin';
import { URL_ADDRESS_PAGE, URL_XHR_ADDRESS_ID } from '@tools/routes/routes';
import { UserAuth } from '@tools/user/auth';
import AddressDetailsDashboardContacts from './AddressDetailsDashboard/AddressDetailsDashboardContacts.vue';
import AddressDetailsDashboardLocation from './AddressDetailsDashboard/AddressDetailsDashboardLocation.vue';
import AddressDetailsDashboardOffers from './AddressDetailsDashboard/AddressDetailsDashboardOffers.vue';

export default {
  components: { AddressDetailsDashboardOffers, AddressDetailsDashboardContacts, AddressDetailsDashboardLocation },
  mixins: [ translationMixin, requestsMixin ],
  props: {
    address: { type: Object, required: true },
  },
  data() {
    return {
      deletable: (window.CHART_DATA.online + window.CHART_DATA.pending) === 0,
      deleting: false,
      deletingConfirmed: false,
    };
  },
  computed: {
    isImpersonated() {
      return UserAuth.isImpersonated();
    },
  },
  methods: {
    async deleteAddress() {
      if (!this.deletable || this.deletingConfirmed) {
        return;
      }

      this.deletingConfirmed = true;

      try {
        await this.delete(URL_XHR_ADDRESS_ID.replace('{id}', this.address.id));
        window.location.href = `${URL_ADDRESS_PAGE}?deleted=1`;
      } catch {
        flashBagError();
        this.deletingConfirmed = false;
      }
    },
  },
};
</script>
